import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { ClockService, ClockZoneTick } from 'src/app/core/services/utelize/general/clock-service';
import { ConfigSystemParams } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { Subscription } from 'rxjs';

@Component({
  selector   : 'app-clock-bar',
  templateUrl: './clock-bar.component.html',
  styleUrls  : ['./clock-bar.component.scss']
})
export class ClockBarComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() cssHeightVarName: string | undefined;
  @Input() showCloseButton : boolean=true;

  @Output() dismissed    : EventEmitter<void  >=new EventEmitter<void  >();
  @Output() heightChanged: EventEmitter<number>=new EventEmitter<number>();

  @ViewChild('clockBar', { static: false }) clockBar?: ElementRef<HTMLDivElement>;

  private ticksSub: Subscription | undefined;

  public ticks: { [key: string]: ClockZoneTick | undefined }={};

  constructor(
    private authenticationService: AuthenticationService,
    private clockService         : ClockService,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService
  ) { }

  public ngOnInit(): void {
    try {
      this.clockService.ensureStarted(this.authenticationService.currentUserObject());

      this.ticksSub=this.clockService.ticks$.subscribe(next => {
        this.ticks=next;
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.publishHeight();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.ticksSub?.unsubscribe();

      if (this.cssHeightVarName)
        document?.documentElement?.style?.setProperty(this.cssHeightVarName, `0px`);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get showTooltips(): boolean {
    try {
      return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTooltips, false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public get zones(): Array<{ key: string; tipTitle: string }> {
    try {
      return this.clockService.zoneDefinitions
                 .filter(z => z.key!=='local')
                 .map(z => ({ key: z.key, tipTitle: z.getTipTitle() }));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  public closeClicked(): void {
    try {
      this.dismissed.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private publishHeight(): void {
    try {
      setTimeout(() => requestAnimationFrame(() => {
        const height=this.clockBar?.nativeElement?.offsetHeight ?? 0;

        if (this.cssHeightVarName)
          document?.documentElement?.style?.setProperty(this.cssHeightVarName, `${height}px`);

        this.heightChanged.emit(height);
      }));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
